import React, { useState } from 'react';
import { TextField, Button, CircularProgress, FormControlLabel, Checkbox } from '@mui/material';
import { createVariant } from '../../api/variants';
import { GroupInterface } from '../../types';

interface CreateVariantFormProps {
  group: GroupInterface;
  onVariantCreated: () => void;
}

interface CreateData {
  name: string;
  price: string;
  quantity: string;
  details: string;
  available: boolean;
  active: boolean;
  is_unlimited: boolean;
}

function CreateVariantForm({ group, onVariantCreated }: CreateVariantFormProps): React.JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<CreateData>({
    name: '',
    price: '',
    quantity: '',
    details: '',
    available: true,
    active: true,
    is_unlimited: false,
  });

  const handleChange = (field: keyof CreateData) => (e: React.ChangeEvent<HTMLInputElement>): void => {
    setData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleCheckboxChange = (field: keyof CreateData) => (e: React.ChangeEvent<HTMLInputElement>): void => {
    setData(prev => ({
      ...prev,
      [field]: e.target.checked
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    if (!data.name.trim()) return;

    setLoading(true);
    try {
      await createVariant({
        name: data.name.trim(),
        group_id: group.id,
        price: data.price === '' ? undefined : Number(data.price),
        quantity: data.quantity === '' ? undefined : Number(data.quantity),
        available: data.available,
        active: data.active,
        details: data.details.trim(),
        is_unlimited: data.is_unlimited,
      });

      // Reset form
      setData({
        name: '',
        price: '',
        quantity: '',
        details: '',
        available: true,
        active: true,
        is_unlimited: false,
      });

      onVariantCreated();
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="שם"
        value={data.name}
        onChange={handleChange('name')}
        required
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="מחיר"
        type="number"
        value={data.price}
        onChange={handleChange('price')}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="כמות"
        type="number"
        value={data.quantity}
        onChange={handleChange('quantity')}
        fullWidth
        sx={{ mb: 2 }}
      />
      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
        <FormControlLabel
          control={<Checkbox checked={data.is_unlimited} onChange={handleCheckboxChange('is_unlimited')} />}
          label="כמות ללא הגבלה"
        />
        <FormControlLabel
          control={<Checkbox checked={data.available} onChange={handleCheckboxChange('available')} />}
          label="מופיע בחנות"
        />
        <FormControlLabel
          control={<Checkbox checked={data.active} onChange={handleCheckboxChange('active')} />}
          label="פעיל"
        />
      </div>
      <TextField
        label="פרטים"
        value={data.details}
        onChange={handleChange('details')}
        fullWidth
        multiline
        rows={3}
        sx={{ mb: 2 }}
      />
      <Button type="submit" variant="contained" disabled={loading}>
        {loading ? <CircularProgress size={20} /> : 'צור קורס'}
      </Button>
    </form>
  );
}

export default CreateVariantForm; 